// extracted by mini-css-extract-plugin
export var container = "_94-0";
export var icon = "_94-1";
export var text = "_94-2";